import { render, staticRenderFns } from "./MasterStoresView.vue?vue&type=template&id=67a8df7b&"
import script from "./MasterStoresView.vue?vue&type=script&lang=ts&"
export * from "./MasterStoresView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports